module.exports = __webpack_public_path__ + "66e20b4bf4e6abd86026b93c3d3b4efe.png";